import { Link } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';
import './Footer.css';

function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <Link to="/abogados" className="footer__brand">
          <img src="/img/pfalconlogo.png" alt="Falcon Abogados" className="footer__logo" />
        </Link>
        <p className="footer__copy">
          {t('footer.copy', { year: currentYear })}
        </p>
        <nav className="footer__nav" aria-label="Footer">
          <a href="/abogados">{t('nav.home')}</a>
          <a href="/abogados#services">{t('nav.services')}</a>
          <a href="/abogados#about">{t('nav.about')}</a>
          <a href="/abogados#contact">{t('nav.contact')}</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
